import {Pathname} from 'interfaces/Routes.types'
import {FC} from 'react'
import {Helmet} from 'react-helmet'
import {useSEO} from './useSEO'
import {dopeTitleSEO} from 'definitions/constant'

interface Props {
  pathname: Pathname
}

export const SEOHelmet: FC<Props> = ({pathname}) => {
  const {title: pathTitle, description} = useSEO(pathname)
  const title = pathTitle ? `${dopeTitleSEO} — ${pathTitle}` : dopeTitleSEO
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  )
}
